<div class="dialog">
    <div class="dialog-header">
        <h3 *ngIf="data.userType === 'client'">{{ 'COMPLAINT|Klient:' | translate }}</h3>
        <h3 *ngIf="data.userType === 'authorizedRetailer'">{{ 'COMPLAINT|Sprzedający (APS):' | translate }}</h3>
        <h3 *ngIf="data.userType === 'distributor'">{{ 'COMPLAINT|Dystrybutor:' | translate }}</h3>
        <h3 *ngIf="data.userType === 'manufacturer'">{{ 'COMPLAINT|Producent:' | translate }}</h3>
        <button
                iccIconButton
                (click)="close()"
                appearance="flat"
            >
            <icc-icon name="close"></icc-icon>
        </button>

    </div>
    <div class="dialog-body">

        <div class="flex-vertical mb-2 w-100">

            <h3 class="w-100" >{{ 'INTERFACE|Dane:' | translate }}</h3>

            <div class="w-100" >

                <div
                    *ngIf="data.user?.companyName && data.userType !== 'client'"
                    class="flex-horizontal mb-1"
                >
                    <span class="w-30 text-right pr-1 text-uppercase">{{ 'COMPANY|Firma:' | translate }}</span>
                    <span class="w-70 text-left pl-1"> {{ data.user?.companyName }} </span>
                </div>
                <div
                    *ngIf="data.user?.referenceName"
                    class="flex-horizontal mb-1"
                >
                    <span *ngIf="data.userType !== 'client'" class="w-30 text-right pr-1 text-uppercase">{{ data.user.userId !== null && data.user.companyId !== null ? ('CONTACT|Nazwa referencyjna:' | translate) : ('COMPLAINT|Punkt sprzedaży - nazwa:' | translate) }}</span>
                    <span *ngIf="data.userType === 'client'" class="w-30 text-right pr-1 text-uppercase">{{ 'PERSON|Imię i nazwisko:' | translate }}</span>
                    <span class="w-70 text-left pl-1">{{ data.user.referenceName }}</span>
                </div>
                <div
                    *ngIf="data.user?.companyVatNr"
                    class="flex-horizontal mb-1"
                >
                    <span class="w-30 text-right pr-1 text-uppercase">{{ data.user.userId !== null && data.user.companyId !== null ? ('COMPANY|VAT:' | translate) : ('COMPLAINT|Punkt sprzedaży - NIP:' | translate) }}</span>
                    <span class="w-70 text-left pl-1">{{ data.user.companyVatNr }}</span>
                </div>
                <div
                    *ngIf="data.user?.companyVatNrEu"
                    class="flex-horizontal mb-1"
                >
                    <span class="w-30 text-right pr-1 text-uppercase">{{ 'COMPANY|VAT-EU:' | translate }}</span>
                    <span class="w-70 text-left pl-1">{{ data.user.companyVatNrEu }}</span>
                </div>
                <div
                    *ngIf="data.user?.email"
                    class="flex-horizontal mb-1"
                >
                    <span class="w-30 text-right pr-1 text-uppercase" >{{ 'CONTACT|E-mail:' | translate }}</span>
                    <span class="w-70 text-left pl-1">{{ data.user?.email }}</span>
                </div>
                <div
                    *ngIf="data.user?.phoneNumber"
                    class="flex-horizontal mb-1"
                >
                    <span class="w-30 text-right pr-1 text-uppercase">{{ 'CONTACT|Telefon kontaktowy:' | translate }}</span>
                    <span class="w-70 text-left pl-1">{{ data.user.phoneNumber }}</span>
                </div>
                <div
                    *ngIf="data.user?.address"
                    class="flex-horizontal mb-1"
                >
                    <span *ngIf="data.userType !== 'client'" class="w-30 text-right pr-1 text-uppercase">{{ data.user.userId !== null && data.user.companyId !== null ? ('CONTACT|Adres:' | translate) : ('COMPLAINT|Punkt sprzedaży - adres:' | translate) }}</span>
                    <span *ngIf="data.userType === 'client'" class="w-30 text-right pr-1 text-uppercase">{{ 'COMPLAINT|Adres instalacji:' | translate }}</span>
                    <span class="w-70 text-left pl-1">{{ data.user.address }}</span>
                </div>
                <ng-container *ngIf="data.userType !== 'client'">
                    <mat-divider *ngIf="data.responsibleUser?.name && data.user.userId !== null && data.user.companyId !== null" style="padding-bottom: 8px;"></mat-divider>
                    <div
                        *ngIf="data.responsibleUser?.name && data.user.userId !== null && data.user.companyId !== null"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'COMPLAINT|Osoba odpowiedzialna:' | translate }}</span>
                        <span class="w-70 text-left pl-1">{{ data.responsibleUser.name }}</span>
                    </div>
                    <div
                        *ngIf="data.responsibleUser?.phoneNumber"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'CONTACT|tel.:' | translate }}</span>
                        <span class="w-70 text-left pl-1">{{ data.responsibleUser.phoneNumber }}</span>
                    </div>
                    <div
                        *ngIf="data.responsibleUser?.email"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'CONTACT|E-mail:' | translate }}</span>
                        <span class="w-70 text-left pl-1">{{ data.responsibleUser.email }}</span>
                    </div>
                    <mat-divider *ngIf="data.assignedUser?.name" style="padding-bottom: 8px;"></mat-divider>
                    <div
                        *ngIf="data.assignedUser?.name"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'COMPLAINT|Przypisana osoba:' | translate }}</span>
                        <span class="w-70 text-left pl-1">{{ data.assignedUser.name }}</span>
                    </div>
                    <div
                        *ngIf="data.assignedUser?.phoneNumber"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'CONTACT|tel.:' | translate }}</span>
                        <span class="w-70 text-left pl-1">{{ data.assignedUser.phoneNumber }}</span>
                    </div>
                    <div
                        *ngIf="data.assignedUser?.email"
                        class="flex-horizontal mb-1"
                    >
                        <span class="w-30 text-right pr-1 text-uppercase">{{ 'CONTACT|E-mail:' | translate }}</span>
                        <span class="w-70 text-left pl-1">{{ data.assignedUser.email }}</span>
                    </div>
                </ng-container>
            </div>

        </div>

    </div>

    <div class="dialog-footer">

        <div class="flex-horizontal w-100">

            <button
                iccButton
                (click)="close()"
                appearance="secondary"
            >
                {{ 'INTERFACE|Zamknij' | translate}}
            </button>

        </div>
    </div>

</div>
<div
    class="curtain"
    (click)="close()"
></div>